<!--
 * @FileDescription: 设置信用额度对话框
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="设置信用额度" :visible.sync="visible" width="500px" :before-close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="邮箱/手机号" prop="showName">{{ form.showName }}</el-form-item>
      <el-form-item label="可用额度" prop="usable">{{ form.usable }}</el-form-item>
      <el-form-item label="总信用额度" prop="creditLimit">
        <el-input-number v-model="form.creditLimit" size="medium" controls-position="right" :min="0" :max="999999999" />
      </el-form-item>
      <el-form-item label="生成类型" prop="billType">
        <el-select v-model="form.billType" size="medium" placeholder="请选择生成类型">
          <el-option v-for="item in generateTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="账期周期" prop="billCycle">
        <el-select v-model="form.billCycle" size="medium" placeholder="请选择账期周期">
          <el-option v-for="item in paymentDaysOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="save">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'

let form = {
  id: undefined,
  creditLimit: undefined, // 信用额度
  billType: undefined, // 生成类型
  billCycle: undefined, // 账期周期
  billBatchQty: undefined, // 生成账单订单数量
  showName: undefined, // 用户邮箱/手机号
  usable: undefined // 可用额度
}

export default {
  data() {
    return {
      visible: false,

      form: { ...form },
      rules: {
        creditLimit: { required: true, message: '请输入总信用额度', trigger: ['blur', 'change'] },
        billType: { required: true, message: '请选择生成类型', trigger: ['blur', 'change'] },
        billCycle: { required: true, message: '请选择账期周期', trigger: ['blur', 'change'] }
      },

      // 生成类型下拉选项
      generateTypeOptions: [
        { label: '按付款时间', value: 1 },
        { label: '按发货时间', value: 2 }
      ],

      // 账单周期下拉选项
      paymentDaysOptions: [
        { label: '15天', value: 15 },
        { label: '30天', value: 30 },
        { label: '45天', value: 45 },
        { label: '60天', value: 60 },
        { label: '90天', value: 90 },
        { label: '120天', value: 120 }
      ]
    }
  },
  methods: {
    /**
     * API 修改单个信用用户
     */
    async updateSingleBillsQty() {
      let form = { ...this.form }
      delete form.showName
      delete form.usable
      let { code, message } = await API.updateSingleBillsQty(this.form)
      if (code === 10000) {
        this.close()
        this.$emit('update')
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 显示对话框
     */
    show(payload) {
      this.visible = true
      this.form.id = payload.id
      this.form.creditLimit = payload.creditLimit
      this.form.showName = payload.showName
      this.form.billType = payload.billType
      this.form.billCycle = payload.billCycle
      this.form.usable = payload.creditLimit && (payload.usedLimit || payload.usedLimit === 0) ? (payload.creditLimit - payload.usedLimit < 0 ? 0 : `+US$${(payload.creditLimit - payload.usedLimit).toFixed(2)}`) : '-'
    },

    /**
     * 保存
     */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateSingleBillsQty()
        } else {
          return false
        }
      })
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据
     */
    clear() {
      this.form = { ...form }
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select,
.el-input-number {
  width: 100%;
}

.el-input-number {
  /deep/.el-input__inner {
    text-align: start;
  }
}
</style>
